import { setUserData, setUserToken } from "./features/userSlice";
import { authService } from "./logic/authService";
import { getUserDetails, loginService } from "./services/login.service";
import store from "./store";
import { navigateTo } from "./utils/navigation";

export async function initClientSide(setResponse: any): Promise<string | null> {
  try {
    // Call refresh endpoint — browser sends HttpOnly refresh cookie automatically
    const res = await loginService.refresh();
    if (res?.data?.access_token) {
      authService.setToken(res.data.access_token);
      store.dispatch(setUserToken(res.data.access_token));
      authService.setAccessTokenExpiration(res.data.access_token_expires_at);
    } else {
      authService.clearToken();
      navigateTo("/login");
      throw new Error("Refresh failed");
    }

    if (res?.data?.access_token) {
      authService.setToken(res.data.access_token);
      authService.setAccessTokenExpiration(res.data.access_token_expires_at);
      store.dispatch(setUserToken(res.data.access_token));
      try {
        const me = await getUserDetails(res.data.access_token);
        if (me?.data) {
          store.dispatch(setUserData({ ...me }));
        }
      } catch (e) {
        console.error("Failed to fetch /me after login", e);
      }
      setResponse(res);
      return res.data.access_token;
    }
    return null;
  } catch (e) {
    console.error("initClientSide: refresh failed", e);
    return null;
  }
}
